module.exports = __webpack_public_path__ + "img/2.35dda870.png";